var content = require("!!../../../../../node_modules/next/node_modules/css-loader/dist/cjs.js??ref--5-oneOf-3-1!../../../../../node_modules/next/dist/compiled/postcss-loader/index.js??__nextjs_postcss!../../../../../node_modules/resolve-url-loader/index.js??ref--5-oneOf-3-3!../../../../../node_modules/next/node_modules/sass-loader/dist/cjs.js??ref--5-oneOf-3-4!./styles.module.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = function(element){// These elements should always exist. If they do not,
// this code should fail.
var anchorElement=document.querySelector('#__next_css__DO_NOT_USE__');var parentNode=anchorElement.parentNode;// Normally <head>
// Each style tag should be placed right before our
// anchor. By inserting before and not after, we do not
// need to track the last inserted element.
parentNode.insertBefore(element,anchorElement)// Remember: this is development only code.
//
// After styles are injected, we need to remove the
// <style> tags that set `body { display: none; }`.
//
// We use `requestAnimationFrame` as a way to defer
// this operation since there may be multiple style
// tags.
;(self.requestAnimationFrame||setTimeout)(function(){for(var x=document.querySelectorAll('[data-next-hide-fouc]'),i=x.length;i--;){x[i].parentNode.removeChild(x[i]);}});};
options.singleton = false;

var update = require("!../../../../../node_modules/next/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}

if (module.hot) {
  if (!content.locals) {
    module.hot.accept(
      "!!../../../../../node_modules/next/node_modules/css-loader/dist/cjs.js??ref--5-oneOf-3-1!../../../../../node_modules/next/dist/compiled/postcss-loader/index.js??__nextjs_postcss!../../../../../node_modules/resolve-url-loader/index.js??ref--5-oneOf-3-3!../../../../../node_modules/next/node_modules/sass-loader/dist/cjs.js??ref--5-oneOf-3-4!./styles.module.scss",
      function () {
        var newContent = require("!!../../../../../node_modules/next/node_modules/css-loader/dist/cjs.js??ref--5-oneOf-3-1!../../../../../node_modules/next/dist/compiled/postcss-loader/index.js??__nextjs_postcss!../../../../../node_modules/resolve-url-loader/index.js??ref--5-oneOf-3-3!../../../../../node_modules/next/node_modules/sass-loader/dist/cjs.js??ref--5-oneOf-3-4!./styles.module.scss");

        if (typeof newContent === 'string') {
          newContent = [[module.id, newContent, '']];
        }
        
        update(newContent);
      }
    )
  }

  module.hot.dispose(function() { 
    update();
  });
}